// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/FunctionalitiesGrid/functionalitiesGrid.css
// module id = 772
// module chunks = 1